import React from 'react';
import classNames from 'classnames';
import './InstallScriptInstructions.pcss';
import TextInput from '../../../../../common/components/TextInput';
import CopyToClipboard from 'react-copy-to-clipboard';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import FormFieldWrapper from '../../../../../common/components/FormFieldWrapper/FormFieldWrapper';

type Props = {
  className?: string;
  helpLinkHref?: string;
  codeToCopy: string;
};

export const InstallScriptInstructions = ({
  className,
  codeToCopy,
  helpLinkHref,
}: Props) => {
  return (
    <FormFieldWrapper
      label="Install code on Website"
      className={classNames(
        className,
        'start-bot-promoter-editor__field install-script-instructions__wrapper',
      )}
    >
      {helpLinkHref && (
        <div className="install-script-instructions__help-text">
          <p>
            {
              'Paste the code below before the </head> tag on every page you want it to appear.'
            }
          </p>
          <p>
            Need some help? Click
            <a
              className="install-script-instructions__help-link"
              href={helpLinkHref}
              target="_blank "
              rel="noopener noreferrer"
            >
              here
            </a>
            for more details!
          </p>
        </div>
      )}

      <div className="install-script-instructions__code-input-wrapper">
        <TextInput
          readOnly={true}
          className="install-script-instructions__code-input"
          value={codeToCopy}
        />

        <CopyToClipboard text={codeToCopy}>
          <PrimaryButton>Copy</PrimaryButton>
        </CopyToClipboard>
      </div>
    </FormFieldWrapper>
  );
};
